// extracted by css-extract-rspack-plugin
export default {"ExpandSection":"ReviewMenu-module__ExpandSection__HBJKw","AnchoredReviewBody":"ReviewMenu-module__AnchoredReviewBody__kV00L"};